import React from 'react';

import InventoryExpiringProductList from 'components/Tvendo/Inventory/InventoryExpiringProduct/List.js';

export default function () {
  return <InventoryExpiringProductList />;
}
